import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { baseHttpRequestOptions } from '../services.utils';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  API_CONTRACTS_URL = environment.apiURL + '/' + 'terms';

  constructor(private httpClient: HttpClient) {}

  // TODO: Terms service
  sendTerms(payload): Observable<any> {
    return this.httpClient.post<any>(
      this.API_CONTRACTS_URL,
      payload,
      baseHttpRequestOptions
    );
  }

  // TODO: getTerms service
  getTerms(cpf): Observable<any> {
    return this.httpClient.get<any>(
      `${this.API_CONTRACTS_URL}/${cpf}`,
      baseHttpRequestOptions
    );
  }

  // TODO: getFormTerms
  getFormsTerms(formId): Observable<any> {
    return this.httpClient.get<any>(
      `${this.API_CONTRACTS_URL}/form/${formId}`,
      baseHttpRequestOptions
    );
  }
}
